<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12" xl="12">
				<b-card>
					<div slot="header">
					<strong>{{this.$route.params.id == 'add' ? 'PatternAdd' : 'PatternEdit'}}</strong>
            <label class="switch switch-sm switch-text switch-info mb-0" title="Pattern Use">
              <input type="checkbox" class="switch-input" v-model="model.is_use" id="use" >
              <span class="switch-label" data-on="ON" data-off="OFF"></span>
              <span class="switch-handle"></span>
            </label>
					</div>
          <b-form-group>
            <label for="category">Category</label>
            <b-form-select v-model="model.category" :options="codes.code_category"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="ext">Ext</label> : {{model && model.ext}}
          <b-form-select v-model="model.ext" :options="codes.code_ext"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="type">Type</label>
            <b-form-select v-model="model.type" :options="codes.code_type"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="code">Code</label>
            <b-form-input md=5 :state="model.type == '1' ? regex_valid(model.code) : (model.code && model.code.length > 0) || false" type="text" id="code" v-model="model.code"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label for="descript">Description</label>
            <b-form-textarea :rows="3" v-model="model.description" id="descript"></b-form-textarea>
          </b-form-group>
          <b-form-group label="Active Use" label-for="ph_active" v-b-tooltip.hover>
            <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
          <hr>
          <b-button size="sm" variant="success" @click="save"> Save </b-button>
          <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
				</b-card>
			</b-col>
		</b-row>
		<router-view></router-view>
	</div>
</template>

<script>
import codes from '@/codes'
import { Api } from '@/service';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components: {
    cSwitch,
  },
	data : () => { return { lock : false, codes : codes, model : { } } },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel: function() { this.$router.replace({ name: 'wsfinder_upattern', params: { id: this.model.id}}); },
    list: function() { this.$router.push({ name: 'wsfinder_upattern'}); },
    async save() {
      if(!(this.model.type)) { return this.$toastr.e('Type is Require.'); }
      if(!(this.model.ext)) { return this.$toastr.e('Ext is Require.'); }
      if(!(this.model.category)) { return this.$toastr.e('Category is Require.'); }
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Code is Require.'); }

      if(!this.regex_valid(this.model.code)) { return this.$toastr.e("No vaild expression"); }

      try {
        let rs = await Api.Manager_Call('wsfinder.user.pattern', this.model.id ? 'update' : 'insert', this.model)
        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name);this.cancel();
        } else {
          this.$toastr.s('Save', 'failed'); this.list()
        }
         this.$emit('refresh');
        return;
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.edit.vue', 'load item', id);
      if(id !== 'add') {
        try {
          let rs = await Api.Manager_Call('wsfinder.user.pattern', 'detail', {id : id});
          this.model = Object.assign({}, this.model, rs.body);
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText),this.cancel(); }
      }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('pattern.edit.vue', 'created'); },
  destroyed: function() { console.log('pattern.edit.vue', 'destroyed'); },
  mounted: function() {
  	console.log('pattern.edit.vue', 'mounted');
  	this.get(this.$route.params.id);
  }
}
</script>
